export default "/images/8e69624f99687a325926c2668de3b9f3.avif";